import { useAtom } from 'jotai';
import { isSidePanelOpenAtom } from '../atoms';

/**
 * Custom hook to manage SidePanel state
 * Provides functions to open and close the side panel
 */
export const useSidePanel = () => {
  const [isSidePanelOpen, setIsOpen] = useAtom(isSidePanelOpenAtom);

  const openSidePanel = () => {
    setIsOpen(true);
  };

  const closeSidePanel = () => {
    setIsOpen(false);
  };

  const toggleSidePanel = () => {
    setIsOpen((prevState) => !prevState);
  };

  return {
    isSidePanelOpen,
    openSidePanel,
    closeSidePanel,
    toggleSidePanel,
  };
};
